import { render, staticRenderFns } from "./OrdersList.vue?vue&type=template&id=6aa5ed55&"
import script from "./OrdersList.vue?vue&type=script&lang=ts&"
export * from "./OrdersList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports